export default __webpack_public_path__ + "static/media/imperialOpen.f5a4aec3.jpg";